import { matchPath } from "react-router";
import { RoutesPath } from "./routes";

const routeRules = [
  {
    match: RoutesPath.LINK_LOCATION,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_MENU,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_RECAP,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_INFO_DETAILS,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_CONFIRM_ORDER,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_WAITING_APPROVAL,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_THANKS,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_SIGNIN,
    requiresTable: false,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
  {
    match: RoutesPath.LINK_PAYMENT,
    requiresTable: true,
    fallback: RoutesPath.LINK_HOMEPAGE
  },
];

const buildRoute = (route: string, params: Record<string, string|undefined>) => {
  return Object.keys(params).reduce(
    (acc, key) => acc.replace(`:${key}`, params[key] ?? ""),
    route
  );
};

export const getRouteRule = (path: string, params: Record<string, string|undefined>) => {
  const rule = routeRules.find(rule =>
    matchPath({ path: rule.match, end: true }, path)
  );

  if (rule) {
    rule.fallback = buildRoute(rule.fallback, params);
  }

  return rule;
};